module.exports = __webpack_public_path__ + "ae04974345d8c3c3f2860190869b3373.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_alpha_2x.png
// module id = 115
// module chunks = 0 1 2 3 4